import React from 'react'
import TrainingBanner from '../Training/TrainingBanner'
import TrainingOperation from '../Training/TrainingOperation'
import TrainingService from '../Training/TrainingService'
import TrainingResult from '../Training/TrainingResult'
import TrainingServiceWork from '../Training/TrainingServiceWork'
import HealthcareFacility from '../../Industries/Healthcare/HealthcareFacility'
import HealthcareFaq from '../../Industries/Healthcare/HealthcareFaq'
import TrainingMastery from '../Training/TraingMastery'
import ProjectTestimonial from './ProjectTestimonial'


export default function ProjectPlaning() {

  const Banner = {
    image: "/assets/images/planing-banner-img.webp",
    heading: "Built Right From Day One",
    description: "Facility layout, equipment sizing, utility planning, and workflow design handled by specialists who understand industrial laundry operations from the ground up.",
    buttonText: "Get Started Today",
    link: "/contact",
  }
  const operationData = {
    subtitle: "Professional Consulting Services ",
    headingLine1: "From Site Survey ",
    headingLine2: "To Fully Optimised Facility",
    description: "With our team of Supershine planning specialists, identify operational gaps and build a stronger foundation through a detailed facility assessment. Our structured service covers space utilisation, equipment sizing, workflow sequencing, and utility requirements, delivering a practical action plan with clear recommendations and step-by-step implementation guidance for reliable, long-term operational performance.",
    buttonText: "Get Started Today",
    buttonLink: "/contact"
  }
  const trainingData = {
    title: "Why Does Planning Matter?",
    description: "Skipping the planning stage is where most facilities lose money before operations even begin. A structured assessment catches equipment mismatches, layout inefficiencies, and utility gaps early, before they become expensive fixes. Our evaluation gives your facility a clear, data-backed foundation so every investment you make works harder from day one.",
    image: "/assets/images/planing-service-img.webp",
    buttonText: "Request Assessment",
    link: "/contact",
  }
  const resultData = {
    heading: " Right Inputs. Better Outcomes.",
    description: "Every well-run laundry facility starts with decisions made before the machines arrive. Our planning process gives you the structure, clarity, and expert input to get those decisions right.",
    items: [
      {
        image: "/assets/images/plan-img1.webp",
        title: "Facility And Equipment Audit",
        text: "We evaluate your existing setup to surface inefficiencies, capacity gaps, and equipment mismatches before they affect output."
      },
      {
        image: "/assets/images/plan-img2.webp",
        title: "Load-Based Capacity Planning",
        text: "We size every machine and workflow stage around your actual daily load, not generic industry averages."
      },
      {
        image: "/assets/images/plan-img3.webp",
        title: "Utility And Cost Mapping",
        text: "We analyse water, power, and steam requirements to reduce running costs and eliminate avoidable waste from day one."
      },
      {
        image: "/assets/images/plan-img4.webp",
        title: "On-Ground Implementation Support",
        text: "We stay involved through installation and commissioning so the plan on paper becomes the facility that actually runs.",
        extraClass: "last-training-col"
      }
    ]
  }
  const ServiceFaq = {
    heading: "Where Preparation <br> Meets Precision",
    image: "/assets/images/solutions-image.webp",
    alt: "Teenager Smiling",
    faqs: [
      {
        question: "Equipment Handover And Site Activation",
        answer: "Full coordination between our team and yours during installation, ensuring every machine is tested, calibrated, and ready before operations begin.",
      },
      {
        question: "Workflow Efficiency Assessment",
        answer: "A detailed review of how work moves through your facility, from intake to dispatch, to remove bottlenecks and improve throughput without adding headcount.",
      },
      {
        question: "Chemical And Programme Optimisation",
        answer: "Wash cycles, temperatures, and dosing levels set to match your exact linen mix, reducing chemical waste while maintaining consistent hygiene outcomes.",
      },
      {
        question: "Resource Consumption Reduction",
        answer: "Targeted planning around water, energy, and steam usage built into your facility from the start, so efficiency is structural, not an afterthought.",
      },
    ],

  };
  const masteryData = {
    headingLine1: "Less Downtime Starts ",
    headingLine2: "At The Planning Stage",
    description: "Facilities that are planned well run well. Our specialists work through every detail before installation begins so your operation starts strong and stays that way.",
    buttonText: "Learn more",
    buttonLink: "/contact",
    bgImage: "/assets/images/project-planing-bg.webp",
  }
  const facilityData = {
    title: "Which Operations Benefit Most?",
    items: [
      {
        icon: "/assets/images/hotel-img1.webp",
        heading: " Hotels And Hospitality",
        description: "Linen-heavy operations with strict turnaround timelines and guest-facing quality standards that leave no room for equipment or process failures."
      },
      {
        icon: "/assets/images/hotel-img2.webp",
        heading: "Industrial Laundries",
        description: "High-throughput facilities processing large daily volumes where machine sizing, cycle efficiency, and uptime directly impact revenue."
      },
      {
        icon: "/assets/images/hotel-img3.webp",
        heading: "Hospitals And Healthcare",
        description: "Infection control, wash temperature compliance, and traceability requirements that demand precision at every stage of the laundry process."
      },

      {
        icon: "/assets/images/hotel-img4.webp",
        heading: "Multi-Site Facility Groups",
        description: "Operators managing laundry across multiple locations who need standardised processes, consistent output, and centralised oversight."
      },

      {
        icon: "/assets/images/hotel-img5.webp",
        heading: "Property & Facility Teams",
        description: "On-premise laundry setups within residential or managed properties where space, utility costs, and reliability are the primary concerns."
      },


      {
        icon: "/assets/images/hotel-img6.webp",
        heading: " Educational Institute",
        description: "Universities, defence establishments, and large residential campuses with consistent daily volumes and long-term operational cost targets."
      }
    ]
  };
  const expertData = {
    title: "Support That Stays As Long As You Need It",
    description: "From first assessment through to day-to-day operations, our team is on hand to resolve issues, refine processes, and ensure your facility continues to perform at the level it was planned for, not just at launch but across every shift that follows.",
    image: "/assets/images/real-image.webp",
    buttonText: "Get Expert Support",
    link: "/contact",
  }
  const faqData = {
    title: "FAQs",
    description:
      "Straight answers to help you plan your laundry facility with confidence.",
    buttonText: "Talk to an expert",
    buttonLink: "/contact",
    faqs: [
      {
        question: "What Does The Supershine Planning Assessment Cover?",
        answer: "The assessment covers your facility layout, daily linen volume, equipment sizing, utility requirements, and workflow sequencing. You receive a detailed report with specific recommendations, not a generic checklist.",
      },
      {
        question: " How Long Does The Planning Process Take?",
        answer: "Timelines vary depending on facility size and complexity. Most assessments are completed within a few working days, with the full planning document delivered shortly after the site visit.",
      },
      {
        question: " Do You Work With Facilities That Are Already Operational?",
        answer: "Yes. We work with both new setups and existing operations looking to improve throughput, reduce running costs, or upgrade equipment without disrupting day-to-day output.",
      },

      {
        question: "What Happens After The Plan Is Delivered?",
        answer: "Our team stays involved through equipment procurement, installation, and commissioning. We do not hand over a document and disappear, we see the plan through to an operational facility.",
      },

      {
        question: "Can The Plan Be Adjusted As The Project Progresses?",
        answer: "Absolutely. Facility requirements shift during a project and our planning process is built to accommodate that. We revise recommendations as new information or constraints emerge on site.",
      },

      {
        question: " Is Operator Training Part Of The Service?",
        answer: "Yes. Once your facility is commissioned, we provide hands-on guidance for your team covering equipment operation, wash programming, and routine maintenance procedures.",
      },
    ],
  };


   const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/project-planing",
                name: "Project Planing"
            }
        ]
    }


  return (
    <>
      <TrainingBanner data={Banner}  breadcrumb={bannerData.breadcrumb}/>
      <TrainingOperation data={operationData} />
      <TrainingService data={trainingData} />
      <TrainingResult data={resultData} />
      <TrainingServiceWork data={ServiceFaq} />
      <TrainingMastery data={masteryData} />
      <HealthcareFacility data={facilityData} />
      {/* <ProjectTestimonial /> */}
      <TrainingService data={expertData} />
      <HealthcareFaq data={faqData} />
    </>
  )
}



